import { forwardRef } from 'react';

const TableFooter = forwardRef<HTMLTableSectionElement>((props, ref) => (
  <tfoot {...props} className='!static' ref={ref} />
));

TableFooter.displayName = 'TableFooter';

export default TableFooter;
